module.exports = __webpack_public_path__ + "assets/issFrontend/img/app-store-badge.734bc67d.png";


//////////////////
// WEBPACK FOOTER
// ./modules/issFrontend/assets/img/app-store-badge.png
// module id = ./modules/issFrontend/assets/img/app-store-badge.png
// module chunks = 1